import { Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ImportNodesComponent } from '../../../../../node/modals/import-nodes/import-nodes.component';
import { NodeService } from '../../../../../../core/services/node.service';
import { HpcConfig } from '../../../../../../core/models/node-config';
import { NodeConfigService } from '../../../../../../core/services/node-config.service';
import { saveAs } from 'file-saver';


@Component({
  selector: 'app-import-node-configurator',
  standalone: false,
  templateUrl: './import-node-configurator.component.html',
  styleUrl: './import-node-configurator.component.scss'
})
export class ImportNodeConfiguratorComponent {

  fileName: string;
  importArray: HpcConfig[] = [];
  @ViewChild('fileUpload') fileUpload;

  constructor(
    public dialog: MatDialogRef<ImportNodesComponent>,
    private snackBar: MatSnackBar,
    private nodeConfigService: NodeConfigService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      importType: string,
      requiredParams: string,
      uniqueFields: string
    },
  ) { }

  ngOnInit(): void { }

  onClose() {
    this.dialog.close(false);
  }

  onSubmit() {
    if (this.importArray.length > 0) {
      this.nodeConfigService.addNewNodeConfigs(this.importArray).subscribe({
        next: (data: any) => {
          if (data?.message) {
            this.snackBar.open(data.message, 'Ok')
          }
        }, error: (err) => {
        }
      });
      this.snackBar.open("Nodes addition in progress.", 'Ok')
      this.dialog.close();
    }
  }

  onFileSelected(event) {
  const file: File = event.target.files[0];
  if (file) {
    try {
      this.importArray.length = 0;
      this.fileName = file.name;
      let reader: FileReader = new FileReader();
      reader.readAsText(file);

      reader.onload = (e) => {
        let csv: string = reader.result as string;
        csv = csv.trim();
        let csvToRowArray = csv.split("\r\n").filter(e => !e.includes(",,,,,,,,,,,,,,,"));
        let headers = csvToRowArray[0].split(",").map(a => a.toLowerCase());
        let props = this.data.requiredParams.split(",");

        for (let index = 1; index < csvToRowArray.length; index++) {
          let row = csvToRowArray[index].split(",");
          let user = new HpcConfig(); 

          props.forEach((prop) => {
            const value = row[this.getIndexOfString(prop.toLowerCase(), headers)];
            user[prop] = this.convertValue(value, prop); 
          });

          this.importArray.push(user);
        }
      }
    } catch (error) {
      this.importArray = [];
      this.snackBar.open("Error reading contents of file.");
    }
  }
}

  private convertValue(value: string, prop: string): any {
    if (value === undefined || value === null || value.trim() === '') {
      return null; 
    }

    switch (prop.toLowerCase()) {
    
      
      case 'maxhpcnodes':
      case 'priceperhour':
      
       return Number(value); 
      case 'isrdmasupported':
        return value.trim().toLowerCase() === 'true';
      default:
        return value.trim(); 
    }
  }

  getIndexOfString(value, array: string[]) {
    return array.findIndex(a => a.toLowerCase() == value)
  }

  onFileChange() {
    this.fileUpload.nativeElement.value = "";
  }

  get formattedRequiredParams(): string {
    return this.data.requiredParams
      ? this.data.requiredParams.split(',').map(param => param.trim()).join(', ')
      : '';
  }

  downloadTemplate() {
    let headers = this.data.requiredParams.split(",");
    const header = headers;
    let csv = ["demo,demo,demo,demo,demo,demo,demo,demo,false,demo,demo,demo,demo,demo,NA"];
    csv.unshift(header.join(','));
    let csvArray = csv.join('\r\n');

    var blob = new Blob([csvArray], { type: 'text/csv' })
    saveAs(blob, `ImportNodeTemplate.csv`);
  }

}
